module.exports = __webpack_public_path__ + "img/plan3_book09.cd7a4bbc.png";